module.exports = __webpack_public_path__ + "static/media/cc_back.65c9f358.svg";